import { useCallback, useState } from 'react';
import { LearningResponse, LearningQueryParams, ESnackbarStyle } from 'shared/types';
import { getLearning } from 'services/api/dashboardService';
import { openNotification } from 'utils/notification-utils';

interface UseDashboardLearningResult {
  learning: LearningResponse | null;
  isLoading: boolean;
  error: string | null;
  fetchLearning: (params?: LearningQueryParams) => Promise<void>;
}

const useDashboardLearning = (): UseDashboardLearningResult => {
  const [learning, setLearning] = useState<LearningResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLearning = useCallback(async (params?: LearningQueryParams): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getLearning(params);
      setLearning(response.data);
    } catch (e: any) {
      const errorMessage = e.message || 'Failed to fetch learning data';
      setError(errorMessage);
      openNotification(ESnackbarStyle.ERROR, errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    learning,
    isLoading,
    error,
    fetchLearning
  };
};

export default useDashboardLearning;
